import type { BaseApiResponse, BaseApiResult } from '@/interfaces/service/api.interface';

export const getApiResponsePayload = <T>(response: { data?: T; result?: T }): T | undefined => response.data ?? response.result;

export const normalizeApiResponse = <T>(response: BaseApiResponse<T>): BaseApiResponse<T> => ({
  ...response,
  data: response.data ?? response.result,
  result: response.result ?? response.data
});

export const checkHttpRequestResult = (response: BaseApiResponse<any>): BaseApiResult<any> => {
  const normalizedResponse = normalizeApiResponse(response);
  const { status, data, result, code, message, errorMessage } = normalizedResponse;
  const normalizedStatus = String(status ?? '');
  const errors = Array.isArray(normalizedResponse.errors) ? normalizedResponse.errors : [];
  const primaryError = errors[0];

  if (200 <= Number(status) && Number(status) < 400) {
    return {
      isSuccess: true,
      status: normalizedStatus,
      data,
      result,
      message
    };
  } else {
    return {
      isSuccess: false,
      status: normalizedStatus,
      errors,
      code: code ?? primaryError?.code,
      message: errorMessage ?? primaryError?.message ?? message
    };
  }
};
